import { ReactElement } from 'react';
import { PrivateRouteId, PRIVATE_ROUTE_REGISTRY } from 'constants/routes';

export type SideBarLink = {
  name: ReactElement;
  routeId: PrivateRouteId;
  icon: ReactElement;
};

export type SideBarGroup = {
  name: ReactElement;
  icon: ReactElement;
  subMenu: SideBarLink[];
};

export type SideBarItem = SideBarLink | SideBarGroup;

export const isSideBarGroup = (item: SideBarItem): item is SideBarGroup => 'subMenu' in item;

export const getSideBarItemPermissions = (item: SideBarItem): readonly string[] => {
  if (!isSideBarGroup(item)) {
    return PRIVATE_ROUTE_REGISTRY[item.routeId].anyOfPermissions;
  }

  return Array.from(new Set(item.subMenu.flatMap(({ routeId }) => PRIVATE_ROUTE_REGISTRY[routeId].anyOfPermissions)));
};
